import React from 'react';
import { useSelector } from 'react-redux';
import { getDashboardBackgroundColor } from '@constants/config';
import TaskList from './task-list';
import AddTask from './add-task';
import DotmapsLoader from '@shared/dotmaps-loader';
import EntityCard from '@shared/list-card/entity-card';
import GroupCard from '@shared/list-card/group-card';
import { SELECT_MODE_NONE } from '@shared/ui-library/card/entity-data-card';
import './drawer.scss';

const Drawer = () => {
  const { cycle, loading } = useSelector(state => state.workflow);

  if (loading) {
    return (
      <div styleName="cycle-drawer-container">
        <DotmapsLoader color={getDashboardBackgroundColor()} />
      </div>
    );
  }

  if (!cycle) {
    return null;
  }

  const { entity, group } = cycle;

  return (
    <div styleName="cycle-drawer-container">
      <div styleName="cycle-drawer-header">
        Workflow started on
      </div>
      {/* EntityCard/GroupCard render a DataCard, whose root is a <li> (it's normally used
          inside TaskList's <ul>) - a <ul> here instead of a <div> keeps that <li> valid. */}
      <ul styleName="cycle-drawer-card">
        {entity && entity.id && <EntityCard entity={entity} selectMode={SELECT_MODE_NONE} />}
        {group && group.id && <GroupCard group={group} />}
      </ul>
      <AddTask />
      <TaskList />
    </div>
  );
};

export default Drawer;
